var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m20.378 8.54-1.232 1.853a8.01 8.01 0 0 1-.22 7.592H5.043A8.013 8.013 0 0 1 15.57 6.817l1.853-1.232A10.016 10.016 0 0 0 3.32 18.986a2 2 0 0 0 1.723 1.002h13.873a2 2 0 0 0 1.742-1.001 10.02 10.02 0 0 0-.27-10.458zm-9.806 6.85a2.003 2.003 0 0 0 2.835 0l5.669-8.503-8.504 5.669a2.003 2.003 0 0 0 0 2.835"
  })));
};
export default SvgSpeed;